import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/situacao-tributaria-icms';

export default {
  getOne: (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisar: (params) => {
    return financeiroApi.get(`${PATH}/pesquisar`, { params });
  },
};
